interface ProfileBioProps {
  title: string;
  content: string;
}

export default function ProfileBio({ title, content }: ProfileBioProps) {
  return (
    <div className="flex flex-col gap-1">
      <h2 className="text-sm font-medium">{title}</h2>
      <p>{content}</p>
    </div>
  );
}
